import { Controller } from "@hotwired/stimulus"

import Sortable from 'sortablejs'

// Connects to data-controller="sortable"
export default class extends Controller {
  static targets = ['item']
  static values = { path: String }

  connect() {
    this.sortable = new Sortable(this.element, { onEnd: this.end.bind(this) });

    this.element.classList.add('sortable')

    this.updatePositions();
  }

  updatePositions() {
    this.itemTargets.forEach((child, index) => {
      child.setAttribute('data-position', index + 1);
    });
  }

  update() {
    fetch(this.pathValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ positions: this.positions() })
    });
  }

  positions() {
    return this.itemTargets.map((child) => {
      return { id: child.dataset.id, index: child.dataset.position };
    });
  }

  end(event) {
    this.updatePositions();
    this.update();
  }
}
